module.exports = __webpack_public_path__ + "static/media/07_tearsofhair.d18bf298.jpg";